/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Use_Picker_Search_TaskInputs */

const cs_templates_use_picker_search_task = /** @type {(inputs: Templates_Use_Picker_Search_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat úkol prohlídky…`)
};

const en_templates_use_picker_search_task = /** @type {(inputs: Templates_Use_Picker_Search_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search viewing tasks…`)
};

/**
* | output |
* | --- |
* | "Search viewing tasks…" |
*
* @param {Templates_Use_Picker_Search_TaskInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_use_picker_search_task = /** @type {((inputs?: Templates_Use_Picker_Search_TaskInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Use_Picker_Search_TaskInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_use_picker_search_task(inputs)
	return cs_templates_use_picker_search_task(inputs)
});